import { Text } from "@ilc-technology/luik";
import React from "react";
import QuoteCard from "./QuoteCard";
import { QuoteData } from "../../../contexts/QuoteContext/QuoteContext";

interface ContentErrorProps {
  title: string;
  quote: QuoteData | undefined | null;
}

const QuoteCardWithTitle: React.FC<ContentErrorProps> = ({ title, quote }) => {
  if (quote == null) return null;
  return (
    <div className="my-20 flex flex-col items-center justify-center gap-y-2">
      <Text as="h1" variant="heading-5-bold" className="mb-2" data-testid="error-page-title">
        {title}
      </Text>
      <QuoteCard quote={quote} />
    </div>
  );
};

export { QuoteCardWithTitle };
